
import {watchInitStudentBinder, sanitizeAssignmentData, fetchOrEmpty} from './studentBinderSagas';

const studentBinderSagas = [
  watchInitStudentBinder,
];

export {sanitizeAssignmentData, fetchOrEmpty};
export default studentBinderSagas;
